export default __webpack_public_path__ + "static/media/free5flare.eb7f9a4e.svg";